module.exports = __webpack_public_path__ + "static/img/sp_logo.cb15710.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sp_logo.jpg
// module id = i58q
// module chunks = 1